import { render, staticRenderFns } from "./PartiesInput.vue?vue&type=template&id=0c398c49&"
import script from "./PartiesInput.vue?vue&type=script&lang=js&"
export * from "./PartiesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/hemmelig/components/form/parties/PartiesInput.vue
// module id = null
// module chunks = 